import * as $ from "jquery";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  CommonModule,
  LocationStrategy,
  HashLocationStrategy
} from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { Routes, RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AgmCoreModule } from "@agm/core";

import { FullComponent } from "./layouts/full/full.component";
import { BlankComponent } from "./layouts/blank/blank.component";

import { NavigationComponent } from "./shared/header-navigation/navigation.component";
import { SidebarComponent } from "./shared/sidebar/sidebar.component";
import { BreadcrumbComponent } from "./shared/breadcrumb/breadcrumb.component";

import { Approutes } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SpinnerComponent } from "./shared/spinner.component";

import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { AuthenticationService } from "./authentication/authentication.service";
import { AuthGuard } from "./authentication/auth-guard.service";
import { SDKBrowserModule } from "src/providers/sdk";
import { PartialsModule } from "src/pages/partials/partials.module";
import { NgxToggleModule } from "ngx-toggle";
import { SocketIoModule, SocketIoConfig } from "ng-socket-io";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";

import { FileBrowserModule } from "./file-browser/file-browser.module";

const config: SocketIoConfig = {
  url: "https://smartedafrica.herokuapp.com",
  options: {
    transports: ["websocket"],
    upgrade: false
  }
};
//https://smartedafrica.herokuapp.com
//https://smartedafrica-demo.herokuapp.com/
//http://localhost:3000

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20
};

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent
  ],
  imports: [
    SocketIoModule.forRoot(config),
    FileBrowserModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    PartialsModule,
    SDKBrowserModule.forRoot(),
    HttpClientModule,
    NgbModule.forRoot(),
    NgxToggleModule,
    RouterModule.forRoot(Approutes, {
      useHash: false
      /* enableTracing: true */
    }),
    PerfectScrollbarModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBUb3jDWJQ28vDJhuQZxkC0NXr_zycm8D0"
    }),
    ServiceWorkerModule.register("/ngsw-worker.js", {
      enabled: environment.production
    })
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    AuthenticationService,
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
